import TagManager from 'react-gtm-module';
import {
  hasTargetingConsent,
  hasUserMadeConsentChoice,
  subscribeToConsentChanges,
} from './cookieYesConsent';

export { subscribeToConsentChanges };

/**
 * Gates the server-side Facebook Conversions API call, which never reaches the
 * browser dataLayer and so cannot be gated by CookieYes or GTM consent settings.
 */
export function hasMarketingConsent(): boolean {
  return hasUserMadeConsentChoice() && hasTargetingConsent();
}

/**
 * dataLayer pushes set no cookies, so they are never gated here. GTM loads on
 * every page from public/index.html and each tag decides for itself whether to
 * fire, via its GTM consent settings and the signals CookieYes sends.
 */
export function pushDataLayer(dataLayerArgs: {
  dataLayer: Record<string, unknown>;
}): void {
  TagManager.dataLayer(dataLayerArgs);
}
